import { DefaultProgress } from './default-progress.component';

export default DefaultProgress;
